
$(document).ready(function() {
    const $slider = $('.hero-cards--slider .row-hero-cards-wrapper');

    const setArrowsPosition = function(slick) {
        let $image_box = $(this).find(".card-image-wrapper");
        let $arrows = $(this).find("button.slick-arrow");

        $image_box_height = $image_box.innerHeight();
        $top = $image_box_height / 2;

        $arrows.css("top", $top);
    }

    $slider.on('setPosition', setArrowsPosition);

    $slider.each(function(){
        const $slider = $(this);
        const $slides = $slider.find('.card-wrapper');
        const $proxyLinks = $slider.find('[data-link-proxy]');

        if($proxyLinks.length){
            $proxyLinks.off('click'); // Removing previous proxy link initialization

            $slider.on('init', slick => {
                $proxyLinks.ProxyLink({
                    excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ]
                  });
            });
        }

        $slider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: $slides.length,
            slidesToScroll: 1,
            speed: 500,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                      dots: true,
                      arrows: true,
                      slidesToShow: 1,
                      autoplay: true,
                      autoplaySpeed: 6000
                    }
                }
            ]
        });
    });
});
